import fetch from "@/fetch";
// 查询结果
export const getInquriy = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/inventory/select_goods",
    data: params
  });
};
